"use client";

/**
 * Top-level Pieter Studio navigation bar.
 * Matches the nav from pieter-studio/screens/ps-home.js.
 * Auth integration (Firebase) will replace the placeholder user name
 * and sign-out handler in a later phase.
 */

import Link from "next/link";

interface PieterNavProps {
	userName?: string;
	onSignOut?: () => void;
}

export function PieterNav({ userName, onSignOut }: PieterNavProps) {
	const displayName = userName || "Operator";
	const initial = displayName.charAt(0).toUpperCase();

	return (
		<nav
			style={{
				position: "sticky",
				top: 0,
				height: 56,
				background: "#161616",
				borderBottom: "1px solid #2A2A2A",
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				padding: "0 32px",
				zIndex: 1000,
				flexShrink: 0,
			}}
		>
			{/* Left: brand */}
			<Link
				href="/projects"
				style={{
					fontFamily: "'Alternate Gothic ATF', sans-serif",
					fontSize: 16,
					fontWeight: 400,
					color: "#F5F5F7",
					letterSpacing: "0.01em",
					textDecoration: "none",
				}}
			>
				Pieter Studio
			</Link>

			{/* Right: avatar + name + sign out */}
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: 12,
				}}
			>
				<div
					style={{
						width: 32,
						height: 32,
						borderRadius: "50%",
						background: "#1A1A1A",
						border: "1px solid #2A2A2A",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexShrink: 0,
					}}
				>
					<span
						style={{
							fontFamily: "'Fixture', sans-serif",
							fontSize: 10,
							color: "#7A7570",
							letterSpacing: "0.06em",
						}}
					>
						{initial}
					</span>
				</div>
				<span
					style={{
						fontFamily: "'Fixture', sans-serif",
						fontSize: 11,
						letterSpacing: "0.08em",
						textTransform: "uppercase",
						color: "#F5F5F7",
					}}
				>
					{displayName.toUpperCase()}
				</span>
				{onSignOut && (
					<span
						onClick={onSignOut}
						style={{
							fontFamily: "'Fixture', sans-serif",
							fontSize: 11,
							letterSpacing: "0.08em",
							textTransform: "uppercase",
							color: "#4A4742",
							cursor: "pointer",
						}}
					>
						Sign out
					</span>
				)}
			</div>
		</nav>
	);
}
